import getSvgIcon from '../../../helpers/getSvgIcon';
import rights from '../../../../../components/rights';

const editorIcon = getSvgIcon('open', 'regular', 24);
const deleteIcon = getSvgIcon('delete', 'regular', 24);

function wrapWithPTag(str) {
  const start = str.slice(0, 3);
  const end = str.slice(-4);
  return start === '<p>' && end === '</p>'
    ? str
    : `<p>${str}</p>`;
}

export default function (data) {
  const {
    instance, task,
    isTotalEstimateTask, isJiraRootProject,
    isBaseline, baselineValue,
    cellValue,
    isButton,
  } = data;

  let template = cellValue;

  if (isButton) {
    return `<div class="gantt_tree_content"><div class="text_value">${cellValue}</div></div>`;
  }

  let link = '';

  if (!GT.appMode.isHistory && !GT.appMode.isLink && !GT.appMode.isExport) {
    link = `<div class='tooltip_gantt_show_more' data-testid='gp_autotest_gantt_task_tooltip_show_more'><a>${__('gantt_tooltip_show_more')}</a></div>`;
  }

  const baselineRow = isBaseline
    ? `<div class='text_value baseline_content'><div class='text_value_content'>${baselineValue}</div></div>`
    : '';

  template = `
    <div class='gantt_tree_content inline_editor_task_name_container ${isBaseline ? 'baseline_view' : ''}'>
      <div class='inline_editor_task_name_container_text'>
        <div class='text_value'>
          <div class='text_value_content'>${template}</div>
        </div>
        ${baselineRow}
      </div>
      <div class='tooltip-gantt-html'>
        <div class='tooltip-gantt-html-title'>${template}</div>
        ${task.note ? `<div class="tooltip-delimiter"></div><div class='tooltip-gantt-html-description ql-snow ql-editor'>${wrapWithPTag(task.note)}</div>` : ''}
        ${link}
      </div>
    </div>`;

  if (!isTotalEstimateTask) {
    template += `
      <div class='gantt_grid_fast_button_edit' data-testid='gp_autotest_gantt_task_edit_button'>${editorIcon}</div>
      
      ${isJiraRootProject || !rights.project.hasRight(task.gantt_id, 'delete_task') ? '' : `<div class='gantt_grid_fast_button_delete' data-testid='gp_autotest_gantt_task_delete_button'>${deleteIcon}</div>`}
    `;
  }

  template += '</div>';

  return template;
}
